import { da } from 'date-fns/locale';
import { create } from 'zustand';
import { persist, createJSONStorage, subscribeWithSelector } from 'zustand/middleware';

interface MapSettings {
  showOrderClusters: boolean;
}
interface IConnectionCodeData {
  connectionCode: string;
  countryCode: string;
  createdAt: string;
  restaurantId: string;
}

type CommonPersistentStore = {
  persistentOrderEtaListUpdateDate: string | null;
  setPersistentOrderEtaListUpdateDate: (date: string | null) => void;
  clearExpiredPersistentEtaListUpdateDate: () => void;
  setShowOrderClustersSetting: (show: boolean) => void;
  setOCFTutorialIsActive: (isActive: boolean) => void;
  setConnectionCodeData: (data: IConnectionCodeData | null | boolean) => void;
  settings: MapSettings;
  OCFTutorialIsActive: boolean | undefined;
  connectionCodeData: IConnectionCodeData | null | boolean;
};

export const useCommonPersistentStore = create<CommonPersistentStore>()(
  subscribeWithSelector(
    persist<CommonPersistentStore>(
      (set, get) => ({
        connectionCodeData: false,
        OCFTutorialIsActive: undefined,
        persistentOrderEtaListUpdateDate: null,
        settings: {
          showOrderClusters: true,
        },
        setConnectionCodeData: (data) => {
          set({ connectionCodeData: data });
        },
        setShowOrderClustersSetting: (show: boolean) =>
          set((state) => ({
            settings: {
              ...state.settings,
              showOrderClusters: show,
            },
          })),
        setPersistentOrderEtaListUpdateDate: (date) =>
          set({ persistentOrderEtaListUpdateDate: date }),
        setOCFTutorialIsActive: (isActive: boolean) => set({ OCFTutorialIsActive: isActive }),
        clearExpiredPersistentEtaListUpdateDate: () => {
          const currentDate = new Date();
          const storedDate = get().persistentOrderEtaListUpdateDate;
          if (storedDate) {
            const storedTime = new Date(storedDate);
            const isExpired = currentDate.getTime() - storedTime.getTime() > 60 * 60 * 1000;
            if (isExpired) {
              set({ persistentOrderEtaListUpdateDate: null });
            }
          }
        },
      }),
      {
        name: 'common-persistent-storage',
        storage: createJSONStorage(() => localStorage),
        onRehydrateStorage: () => {
          return (restoredState, error) => {
            if (error) {
              console.log('An error happened during hydration', error);
            } else {
              restoredState?.clearExpiredPersistentEtaListUpdateDate();
              console.log('Hydration finished, expired data cleared.');
            }
          };
        },
      }
    )
  )
);
